export type ProjectType = 'plainchain' | 'matchsystems' | 'hermespro';
export const PROJECT_TYPE: ProjectType = import.meta.env.VITE_TYPE;
export const isProd: boolean = process.env.NODE_ENV === 'production';
